import { HeaderConfig } from '@tenants/types/tenant';

/**
 * Header configuration for the AGNT Inc. investor-relations tenant.
 *
 * Nav items mirror the design at:
 * https://anniewang-exp-exp-world-holdings.vercel.app/index.html
 *
 * All non-home links are served directly by WordPress/WPEngine via nginx
 * path routing — they do not go through Next.js.
 */
export function createHeaderConfig(): HeaderConfig {
  return {
    mainButtonCopy: {
      key: '',
      defaultValue: 'Investor Alerts',
    },
    authButtonCopy: {
      key: '',
      defaultValue: 'Sign In',
    },
    hasJoinExpPage: false,
    hasAdvisorSignIn: false,
    authMenuItems: [],
    menuItems: [
      {
        label: { key: '', defaultValue: 'Why AGNT' },
        link: '/why-agnt',
        id: 'header-why-agnt',
      },
      {
        label: { key: '', defaultValue: 'News' },
        link: '/news',
        id: 'header-news',
      },
      {
        label: { key: '', defaultValue: 'Events & Presentations' },
        link: '/events-and-presentations',
        id: 'header-events',
      },
      {
        label: { key: '', defaultValue: 'Stock Information' },
        link: '/stock-info',
        id: 'header-stock',
      },
      {
        label: { key: '', defaultValue: 'Financials' },
        link: '/financials',
        id: 'header-financials',
      },
      {
        label: { key: '', defaultValue: 'Governance' },
        link: '/governance',
        id: 'header-governance',
      },
      {
        label: { key: '', defaultValue: 'AGNT Businesses' },
        link: '/agnt-businesses',
        id: 'header-agnt-businesses',
      },
      {
        label: { key: '', defaultValue: 'Resources' },
        link: '/resources',
        id: 'header-resources',
      },
    ],
  };
}
